// extracted by mini-css-extract-plugin
module.exports = {"pagination":"data-table_pagination__2AzPe","noSearchResultRender":"data-table_noSearchResultRender__2eTYT","hidePagination":"data-table_hidePagination__W5koF"};